import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiTrash2, FiCamera } from "react-icons/fi";
import { imageArticleUrl } from "../../utils/modules";
import { villesMadagascar } from "../../constant/villesMadagascar";
import { BOOTSTRAP_ICONS } from "../../utils/bootstrapIcons";
import logo from "../../assets/images/logo/logo.png";

const ArticleUpdateModal = ({
  show,
  updateLoading,
  formArticle,
  setFormArticle,
  infoCle,
  categories,
  maxPhotos,
  remainingPhotos,
  onChange,
  onPhotosChange,
  onRemoveOldPhoto,
  onRemoveNewPhoto,
  onClose,
  onConfirm,
  setInfoCle,
}) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [infoValue, setInfoValue] = useState("");
  const navigate = useNavigate();
  const handleAddInfoCle = () => {
    if (!selectedIcon || !infoValue.trim()) return;

    setInfoCle((prev) => [
      ...prev,
      {
        icon: selectedIcon.icon,
        name: selectedIcon.label,
        value: infoValue,
      },
    ]);

    setSelectedIcon(null);
    setInfoValue("");
  };

  const handleRemoveInfoCle = (index) => {
    setInfoCle((prev) => prev.filter((_, i) => i !== index));
  };

  const moveOldPhoto = (index, direction) => {
    setFormArticle((prev) => {
      const arr = [...prev.oldPhotos];
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= arr.length) return prev;

      [arr[index], arr[newIndex]] = [arr[newIndex], arr[index]];
      return { ...prev, oldPhotos: arr };
    });
  };

  const moveNewPhoto = (index, direction) => {
    setFormArticle((prev) => {
      const arr = [...prev.photos];
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= arr.length) return prev;

      [arr[index], arr[newIndex]] = [arr[newIndex], arr[index]];
      return { ...prev, photos: arr };
    });
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-xl modal-fullscreen modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content ">
            <div className="modal-header container container" style={{ border: "none" }}>
              {/* <h5 className="modal-title"></h5> */}
              <img
                src={logo}
                alt="logo"
                className="header_logo"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              />
              <button
                className="btn-close"
                onClick={onClose}
                disabled={updateLoading}
              />
            </div>

            <div className="modal-body container container">
              <h6 className="fw-bold mb-2">
                <FiCamera /> Photos (Max {maxPhotos})
              </h6>

              {remainingPhotos > 0 ? (
                <div className="mb-3">
                  <input
                    type="file"
                    multiple
                    accept="image/*"
                    className="form-control"
                    onChange={onPhotosChange}
                    style={{ borderRadius: "26px" }}
                  />
                  <small className="text-muted">
                    {formArticle.oldPhotos.length +
                      (formArticle.photos?.length || 0)}
                    /{maxPhotos} photos
                  </small>
                </div>
              ) : (
                <div className="alert alert-danger">
                  Limite de photos atteinte
                </div>
              )}

              {formArticle.oldPhotos?.length > 0 && (
                <>
                  <p className="fw-semibold">Photos actuelles :</p>
                  <div className="photo-flex-container">
                    {formArticle.oldPhotos.map((p, i) => (
                      <div key={i} className="photo-card-flex">
                        <img
                          src={`${imageArticleUrl}/${p}`}
                          className="photo-uploaded"
                          alt="ancienne"
                          onClick={() =>
                            setPreviewImage(`${imageArticleUrl}/${p}`)
                          }
                        />

                        <div className="photo-controls">
                          <button
                            onClick={() => moveOldPhoto(i, -1)}
                            disabled={i === 0}
                          >
                            <i className="bi bi-arrow-left-short" />
                          </button>

                          <button
                            onClick={() => onRemoveOldPhoto(i)}
                            className="btn-del"
                          >
                            <i className="bi bi-trash3" />
                          </button>

                          <button
                            onClick={() => moveOldPhoto(i, 1)}
                            disabled={i === formArticle.oldPhotos.length - 1}
                          >
                            <i className="bi bi-arrow-right-short" />
                          </button>
                        </div>

                        {i === 0 && (
                          <span className="main_label_principale">
                            Principale
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}

              {formArticle.photos?.length > 0 && (
                <>
                  <p className="fw-semibold">Nouvelles photos :</p>
                  <div className="photo-flex-container mb-4">
                    {formArticle.photos.map((file, i) => (
                      <div key={i} className="photo-card-flex">
                        <img
                          src={URL.createObjectURL(file)}
                          className="photo-uploaded"
                          alt="nouvelle"
                          onClick={() =>
                            setPreviewImage(URL.createObjectURL(file))
                          }
                        />

                        <div className="photo-controls">
                          <button
                            onClick={() => moveNewPhoto(i, -1)}
                            disabled={i === 0}
                          >
                            <i className="bi bi-arrow-left-short" />
                          </button>

                          <button
                            onClick={() => onRemoveNewPhoto(i)}
                            className="btn-del"
                          >
                            <i className="bi bi-trash3" />
                          </button>

                          <button
                            onClick={() => moveNewPhoto(i, 1)}
                            disabled={i === formArticle.photos.length - 1}
                          >
                            <i className="bi bi-arrow-right-short" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              <hr />

              <div className="mb-3">
                <label className="form-label">Titre *</label>
                <input
                  type="text"
                  name="titre"
                  className="form-control custom_css_field_update"
                  value={formArticle.titre || ""}
                  onChange={onChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Description *</label>
                <textarea
                  name="description"
                  rows="4"
                  className="form-control custom_css_field_update"
                  value={formArticle.description || ""}
                  onChange={onChange}
                  required
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Prix *</label>
                  <input
                    type="number"
                    name="prix"
                    className="form-control custom_css_field_update"
                    value={formArticle.prix || ""}
                    onChange={onChange}
                    min="0"
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">État *</label>
                  <select
                    name="etat"
                    className="form-select custom_css_field_update"
                    value={formArticle.etat}
                    onChange={onChange}
                  >
                    <option value={1}>Neuf</option>
                    <option value={2}>Occasion</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Catégorie *</label>
                <select
                  name="idCategorie"
                  className="form-select custom_css_field_update"
                  value={formArticle.idCategorie || ""}
                  onChange={onChange}
                  required
                >
                  <option value="">-- Choisir --</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.nom}
                    </option>
                  ))}
                </select>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Ville</label>
                  <select
                    name="ville"
                    value={formArticle.ville}
                    onChange={onChange}
                    className="form-select custom_css_field_update"
                  >
                    <option value="">Choisir une ville</option>
                    {[...villesMadagascar].sort().map((ville, index) => (
                      <option key={index} value={ville}>
                        {ville}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Quartier</label>
                  <input
                    type="text"
                    name="quartier"
                    className="form-control custom_css_field_update"
                    value={formArticle.quartier || ""}
                    onChange={onChange}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Téléphone</label>
                <input
                  type="text"
                  name="phone"
                  className="form-control custom_css_field_update"
                  value={formArticle.phone || ""}
                  onChange={onChange}
                />
              </div>

              <hr />
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Type Offre</label>
                  <select
                    name="typeOffre"
                    className="form-select custom_css_field_update"
                    value={formArticle.typeOffre}
                    onChange={onChange}
                  >
                    <option value={1}>Offre</option>
                    <option value={2}>Demande</option>
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Type Abonnement</label>
                  <select
                    name="typeAbonnement"
                    className="form-select custom_css_field_update"
                    value={formArticle.typeAbonnement}
                    onChange={onChange}
                  >
                    <option value={1}>Premium</option>
                    <option value={2}>Standard</option>
                  </select>
                </div>
              </div>

              <hr />
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Id Publication Facebook</label>
                  <input
                    type="text"
                    name="idPublicationFacebook"
                    className="form-control custom_css_field_update"
                    value={formArticle.idPublicationFacebook || ""}
                    onChange={onChange}
                  />        
                </div>
              </div>

              <hr />
              <h6 className="fw-bold d-flex align-items-center gap-2">
                Informations clés
                <i
                  className={`bi ${
                    showIconPicker
                      ? "bi-arrow-up-circle-fill"
                      : "bi-arrow-down-circle-fill"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowIconPicker((v) => !v)}
                />
              </h6>

              {/* PICKER */}
              {showIconPicker && (
                <div className="info-cle-picker mb-3">
                  {BOOTSTRAP_ICONS.map((item, i) => (
                    <button
                      key={i}
                      type="button"
                      className={`icon-choice ${
                        selectedIcon?.icon === item.icon ? "active" : ""
                      }`}
                      onClick={() => setSelectedIcon(item)}
                      title={item.label}
                    >
                      <i className={`bi bi-${item.icon}`} />
                      <span>{item.label}</span>
                    </button>
                  ))}
                </div>
              )}

              {selectedIcon && (
                <div className="d-flex gap-2 mb-3">
                  <input
                    className="form-control"
                    placeholder={`Valeur pour ${selectedIcon.label}`}
                    value={infoValue}
                    onChange={(e) => setInfoValue(e.target.value)}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={handleAddInfoCle}
                  >
                    Ajouter
                  </button>
                </div>
              )}

              <div className="update_info_cle_list">
                {infoCle.map((item, index) => (
                  <div
                    key={index}
                    className="info-cle-chip d-flex align-items-center gap-2"
                  >
                    <i className={`bi bi-${item.icon}`} />
                    <strong>{item.name} :</strong>
                    <span>{item.value}</span>
                    <FiTrash2
                      style={{
                        cursor: "pointer",
                        color: "var(--couleur-secondaire)",
                      }}
                      onClick={() => handleRemoveInfoCle(index)}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer container container" style={{border:"none"}}>
              <button
                className="btn btn-primary utilisateur_profile_form_button"
                onClick={onConfirm}
                disabled={updateLoading}
              >
                {updateLoading ? "Enregistrement..." : "Enregistrer"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {previewImage && (
        <div
          className="image-preview-overlay"
          onClick={() => setPreviewImage(null)}
        >
          <img src={previewImage} alt="preview" />
        </div>
      )}

      <div className="modal-backdrop fade show" />
    </>
  );
};

export default ArticleUpdateModal;
